import racism from './racism';
import online_learing from './online_learning';
import old_people_finland from './old_people_finland';
import equality from './equality';
import favourite_book from './favourite_book';
import favourite_animal from './favourite_animal';
import favourite_tv_show from './favourite_tv_show';
import walking_alone from './walking_alone';
import limit_screen from './limit_screen';
import entrepreneurship from './enterpreunership';
import getting_old from './getting_old';
import favourite_holiday from './favourite_holiday';
import favourite_day from './favourite_day';
import favourite_movie from './favourite_movies';


const essays_ml = [];
  essays_ml.push({ name: 'Racism in Finland', content:racism });
  essays_ml.push({ name: 'Online learning', content:online_learing });
  essays_ml.push({ name: 'Old People in Finland', content:old_people_finland });
  essays_ml.push({ name: 'Equality in Finland', content:equality });
  essays_ml.push({ name: 'Favourite Book', content:favourite_book });
  essays_ml.push({ name: 'Favourite Animal', content:favourite_animal });
  essays_ml.push({ name: 'Favourite TV Show', content:favourite_tv_show });
  essays_ml.push({ name: 'Favourite Movie', content:favourite_movie });
  essays_ml.push({ name: 'Favourite Holiday', content:favourite_holiday });
  essays_ml.push({ name: 'Favourite Day', content:favourite_day });
  essays_ml.push({ name: 'Walking Alone', content:walking_alone });
  essays_ml.push({ name: 'Limit Screen Time', content:limit_screen });
  essays_ml.push({ name: 'Entrepreneurship', content:entrepreneurship });
  essays_ml.push({ name: 'Getting Old', content:getting_old });

export default essays_ml;